import * as React from 'react';
import { FC, CSSProperties } from 'react';

interface IconProps {
  color?: string;
  size?: number;
  style?: CSSProperties;
}

const Play: FC<IconProps> = ({ color = 'white', size = 12, style }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    fill={color} 
    style={style}
  >
    <path d="M72.53,48.09l-41.05-23.7c-0.34-0.2-0.72-0.3-1.1-0.3s-0.76,0.1-1.1,0.3c-0.69,0.4-1.1,1.11-1.1,1.91v47.4  c0,0.8,0.41,1.51,1.1,1.91c0.69,0.4,1.51,0.4,2.2,0l41.05-23.7c0.69-0.4,1.1-1.11,1.1-1.91S73.22,48.49,72.53,48.09z" />
  </svg>
);

export default Play;